import React from "react";
import classNames from "classnames";
import {
  matchPath,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";

import PageSideBar from "components/PageSideBar";
import { AppRoutes, SettingsRoutes } from "pages/constants/routes";
import PaymentMethodsTab from "./components/PaymentMethodsTab";

import styles from "./Settings.module.scss";
import { WalletCards } from "lucide-react";

const getFullRoute = (settingsRoute: string) =>
  AppRoutes.settings + settingsRoute;

const Settings = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className={styles.page}>
      <PageSideBar />
      <div className={styles.content}>
        <div className={styles.tabWithContent}>
          <div className={styles.leftTabGroup}>
            <div className={styles.header}>Settings</div>
            <div className={styles.tabs}>
              {/* <div
                className={classNames(styles.tab, tab == 0 && styles.selected)}
                onClick={() => setTab(0)}
              >
                <UserRoundPen />
                <span>Account</span>
              </div> */}
              <div
                className={classNames(
                  styles.tab,
                  matchPath(
                    getFullRoute(SettingsRoutes.paymentMethods),
                    pathname,
                  ),
                  styles.selected,
                )}
                onClick={() =>
                  navigate(getFullRoute(SettingsRoutes.paymentMethods))
                }
              >
                <WalletCards />
                <span>Payment Methods</span>
              </div>
            </div>
          </div>
          <div className={styles.tabContent}>
            <Routes>
              <Route
                index
                path={SettingsRoutes.paymentMethods}
                element={<PaymentMethodsTab />}
              />
            </Routes>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
